/* eslint-disable @khanacademy/ts-no-error-suppressions -- porting from old code. */
import "./onboarding-animation.less";

import {t} from "@lingui/core/macro";
import * as React from "react";

import {usePrefersReducedMotion} from "@repo/data-prefers-reduced-motion";

export default function OnboardingAnimation({id}): React.ReactElement {
    const reduceMotion = usePrefersReducedMotion();
    return (
        <div
            className="onboarding-animation"
            data-reduce-motion={reduceMotion}
            data-testid="onboarding-animation"
            id={id}
        >
            {[
                t`I'm Khanmigo, an AI-powered guide. I can help you along your learning journey!`,
                t`Let me help you find what you're looking for!`,
                t`Have some fun and power up your knowledge with our learning activities!`,
                t`Play a learning game, review for a test, or talk to someone from history or literature! You choose!`,
            ].map((message) => (
                <span key={message} className="onboarding-animation__message">
                    {message}
                </span>
            ))}
            <span className="onboarding-animation__illustration">
                <GuideSVG />
            </span>
        </div>
    );
}

// A separate component due to the size of the markup
function GuideSVG() {
    return (
        <svg
            width="196"
            height="196"
            viewBox="0 0 196 196"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="guide">
                <path
                    id="back"
                    d="M98 196C152.12 196 196 152.12 196 98C196 43.88 152.12 0 98 0C43.88 0 0 43.88 0 98C0 152.12 43.88 196 98 196Z"
                    fill="#54314C"
                />
                <g id="avatar">
                    <path
                        id="face"
                        d="M61.55 45H134.48C144.18 45 152.03 52.86 152.03 62.55V141.93C152.03 149.59 142.91 153.57 137.29 148.36L131.38 142.88C129.76 141.38 127.63 140.54 125.41 140.54H52.78C47.93 140.54 44 136.61 44 131.76V62.55C44 52.86 51.86 45 61.55 45Z"
                        fill="#DEAE93"
                    />
                    <g id="eyes-down">
                        <g id="eye-left">
                            <circle
                                id="White"
                                cx="21.5"
                                cy="21.5"
                                r="21.5"
                                transform="matrix(1 0 0 -1 52.8999 118.921)"
                                fill="white"
                            />
                            <g id="Pupil mask">
                                <mask
                                    id="mask0_0_1"
                                    // @ts-expect-error - TS2322 - Type '{ masktype: string; }' is not assignable to type 'Properties<string | number, string & {}>'.
                                    style={{masktype: "alpha"}}
                                    maskUnits="userSpaceOnUse"
                                    x="52"
                                    y="75"
                                    width="44"
                                    height="44"
                                >
                                    <circle
                                        id="Eye"
                                        cx="21.5"
                                        cy="21.5"
                                        r="21.5"
                                        transform="matrix(1 0 0 -1 52.8999 118.921)"
                                        fill="white"
                                    />
                                </mask>
                                <g mask="url(#mask0_0_1)">
                                    <circle
                                        id="Pupil"
                                        cx="19.5068"
                                        cy="19.5068"
                                        r="19.5068"
                                        transform="matrix(1 0 0 -1 54.9006 136.897)"
                                        fill="black"
                                    />
                                </g>
                            </g>
                        </g>
                        <g id="eye-right">
                            <circle
                                id="White_2"
                                cx="21.5"
                                cy="21.5"
                                r="21.5"
                                transform="matrix(1 0 0 -1 99.8999 118.921)"
                                fill="white"
                            />
                            <g id="Pupil mask_2">
                                <mask
                                    id="mask1_0_1"
                                    // @ts-expect-error - TS2322 - Type '{ masktype: string; }' is not assignable to type 'Properties<string | number, string & {}>'.
                                    style={{masktype: "alpha"}}
                                    maskUnits="userSpaceOnUse"
                                    x="99"
                                    y="75"
                                    width="44"
                                    height="44"
                                >
                                    <circle
                                        id="Eye_2"
                                        cx="21.5"
                                        cy="21.5"
                                        r="21.5"
                                        transform="matrix(1 0 0 -1 99.8999 118.921)"
                                        fill="white"
                                    />
                                </mask>
                                <g mask="url(#mask1_0_1)">
                                    <circle
                                        id="Pupil_2"
                                        cx="19.5068"
                                        cy="19.5068"
                                        r="19.5068"
                                        transform="matrix(1 0 0 -1 101.901 136.897)"
                                        fill="black"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                    <g id="eyes-front">
                        <g id="eye-left_2">
                            <circle
                                id="White_3"
                                cx="21.5"
                                cy="21.5"
                                r="21.5"
                                transform="matrix(1 0 0 -1 52.8999 118.921)"
                                fill="white"
                            />
                            <g id="Pupil mask_3">
                                <mask
                                    id="mask2_0_1"
                                    // @ts-expect-error - TS2322 - Type '{ masktype: string; }' is not assignable to type 'Properties<string | number, string & {}>'.
                                    style={{masktype: "alpha"}}
                                    maskUnits="userSpaceOnUse"
                                    x="53"
                                    y="76"
                                    width="43"
                                    height="43"
                                >
                                    <circle
                                        id="Eye_3"
                                        cx="21.5"
                                        cy="21.5"
                                        r="21.5"
                                        transform="matrix(1 0 0 -1 53 119)"
                                        fill="white"
                                    />
                                </mask>
                                <g mask="url(#mask2_0_1)">
                                    <circle
                                        id="Pupil_3"
                                        cx="13.5"
                                        cy="13.5"
                                        r="13.5"
                                        transform="matrix(1 0 0 -1 61 111)"
                                        fill="black"
                                    />
                                </g>
                            </g>
                        </g>
                        <g id="eye-right_2">
                            <circle
                                id="White_4"
                                cx="21.5"
                                cy="21.5"
                                r="21.5"
                                transform="matrix(1 0 0 -1 99.8999 118.921)"
                                fill="white"
                            />
                            <g id="Pupil mask_4">
                                <mask
                                    id="mask3_0_1"
                                    // @ts-expect-error - TS2322 - Type '{ masktype: string; }' is not assignable to type 'Properties<string | number, string & {}>'.
                                    style={{masktype: "alpha"}}
                                    maskUnits="userSpaceOnUse"
                                    x="100"
                                    y="76"
                                    width="43"
                                    height="43"
                                >
                                    <circle
                                        id="Eye_4"
                                        cx="21.5"
                                        cy="21.5"
                                        r="21.5"
                                        transform="matrix(1 0 0 -1 100 119)"
                                        fill="white"
                                    />
                                </mask>
                                <g mask="url(#mask3_0_1)">
                                    <circle
                                        id="Pupil_4"
                                        cx="13.5"
                                        cy="13.5"
                                        r="13.5"
                                        transform="matrix(1 0 0 -1 108 111)"
                                        fill="black"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                    <g id="eyes-left">
                        <g id="eye-left_3">
                            <circle
                                id="White_5"
                                cx="21.5"
                                cy="21.5"
                                r="21.5"
                                transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.8999 75.9208)"
                                fill="white"
                            />
                            <g id="Pupil mask_5">
                                <mask
                                    id="mask4_0_1"
                                    // @ts-expect-error - TS2322 - Type '{ masktype: string; }' is not assignable to type 'Properties<string | number, string & {}>'.
                                    style={{masktype: "alpha"}}
                                    maskUnits="userSpaceOnUse"
                                    x="52"
                                    y="75"
                                    width="44"
                                    height="44"
                                >
                                    <circle
                                        id="Eye_5"
                                        cx="21.5"
                                        cy="21.5"
                                        r="21.5"
                                        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.8999 75.9208)"
                                        fill="white"
                                    />
                                </mask>
                                <g mask="url(#mask4_0_1)">
                                    <circle
                                        id="Pupil_5"
                                        cx="19.5068"
                                        cy="19.5068"
                                        r="19.5068"
                                        transform="matrix(-4.37114e-08 1 1 4.37114e-08 34.9238 77.9215)"
                                        fill="black"
                                    />
                                </g>
                            </g>
                        </g>
                        <g id="eye-right_3">
                            <circle
                                id="White_6"
                                cx="21.5"
                                cy="21.5"
                                r="21.5"
                                transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.8999 75.9207)"
                                fill="white"
                            />
                            <g id="Pupil mask_6">
                                <mask
                                    id="mask5_0_1"
                                    // @ts-expect-error - TS2322 - Type '{ masktype: string; }' is not assignable to type 'Properties<string | number, string & {}>'.
                                    style={{masktype: "alpha"}}
                                    maskUnits="userSpaceOnUse"
                                    x="99"
                                    y="75"
                                    width="44"
                                    height="44"
                                >
                                    <circle
                                        id="Eye_6"
                                        cx="21.5"
                                        cy="21.5"
                                        r="21.5"
                                        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.8999 75.9207)"
                                        fill="white"
                                    />
                                </mask>
                                <g mask="url(#mask5_0_1)">
                                    <circle
                                        id="Pupil_6"
                                        cx="19.5068"
                                        cy="19.5068"
                                        r="19.5068"
                                        transform="matrix(-4.37114e-08 1 1 4.37114e-08 81.9238 77.9214)"
                                        fill="black"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                    <g id="eyes-right">
                        <g id="eye-left_4">
                            <circle
                                id="White_7"
                                cx="21.5"
                                cy="21.5"
                                r="21.5"
                                transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 95.8999 118.921)"
                                fill="white"
                            />
                            <g id="Pupil mask_7">
                                <mask
                                    id="mask6_0_1"
                                    // @ts-expect-error - TS2322 - Type '{ masktype: string; }' is not assignable to type 'Properties<string | number, string & {}>'.
                                    style={{masktype: "alpha"}}
                                    maskUnits="userSpaceOnUse"
                                    x="52"
                                    y="75"
                                    width="44"
                                    height="44"
                                >
                                    <circle
                                        id="Eye_7"
                                        cx="21.5"
                                        cy="21.5"
                                        r="21.5"
                                        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 95.8999 118.921)"
                                        fill="white"
                                    />
                                </mask>
                                <g mask="url(#mask6_0_1)">
                                    <circle
                                        id="Pupil_7"
                                        cx="19.5068"
                                        cy="19.5068"
                                        r="19.5068"
                                        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 113.876 116.92)"
                                        fill="black"
                                    />
                                </g>
                            </g>
                        </g>
                        <g id="eye-right_4">
                            <circle
                                id="White_8"
                                cx="21.5"
                                cy="21.5"
                                r="21.5"
                                transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 142.9 118.921)"
                                fill="white"
                            />
                            <g id="Pupil mask_8">
                                <mask
                                    id="mask7_0_1"
                                    // @ts-expect-error - TS2322 - Type '{ masktype: string; }' is not assignable to type 'Properties<string | number, string & {}>'.
                                    style={{masktype: "alpha"}}
                                    maskUnits="userSpaceOnUse"
                                    x="99"
                                    y="75"
                                    width="44"
                                    height="44"
                                >
                                    <circle
                                        id="Eye_8"
                                        cx="21.5"
                                        cy="21.5"
                                        r="21.5"
                                        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 142.9 118.921)"
                                        fill="white"
                                    />
                                </mask>
                                <g mask="url(#mask7_0_1)">
                                    <circle
                                        id="Pupil_8"
                                        cx="19.5068"
                                        cy="19.5068"
                                        r="19.5068"
                                        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 160.876 116.92)"
                                        fill="black"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
